export class Deferred<T> {
    public promise: Promise<T>;
    public resolve!: (value: T) => void;
    public reject!: (reason?: any) => void;

    constructor(promise?: () => T) {
        if (!promise) {
            this.promise = new Promise<T>((resolve, reject) => {
                this.resolve = resolve;
                this.reject = reject;
            });
        } else {
            this.promise = new Promise<T>((resolve, reject) => {
                resolve(promise());
            });
        }
    }

}

//// Usage:
//const deferred = new Deferred<number>();

//// Somewhere else in your code, you can resolve or reject the promise
//deferred.resolve(42);

//// Awaiting the promise
//deferred.promise.then(value => console.log(value)); // Outputs: 42
